(function () {

    'use strict';

    angular.module('md5', [])
        .provider('md5', Md5Provider);

    Md5Provider.$inject = [
        '$windowProvider'
    ];
    function Md5Provider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.md5 || {};
            }
        };
    }
})();
